import { BaseField } from './BaseField';
import { FormStore, FieldDesc } from '../FormStore';
import { precisionType, precisionMetrics} from '@utils/Utils';
import { observable, makeObservable } from 'mobx';
/**
 * 1. 接入组件精度控制属性
 * 2. 接入舍入策略：round floor ceil
 * 3. 接入自定义策略
 */
export interface NumberFieldDesc extends FieldDesc {
  precision?: number,
  precisionMethod?: Function
  usePrecisionInStore?: Boolean
}

interface precisionType {
  ROUND: 'round',
  FLOOR:'floor',
  CEIL: 'ceil'
}


export class NumberField extends BaseField {
  precision?: number
  precisionMethod?: precisionType| Function
  constructor(fieldDesc: NumberFieldDesc, formStore: FormStore) {
    super(fieldDesc, formStore)
    // usePrecisionInStore精度控制是否同步
    this.precision =  fieldDesc?.usePrecisionInStore ? fieldDesc.precision : undefined
    this.precisionMethod = fieldDesc.precisionMethod
    makeObservable(this, {
      precision: observable,
      setPrecisionMethod: observable
    })
  }

  setPrecision(value: number) {
    this.precision = value
  }
  setPrecisionMethod(method?: precisionType | Function) {
    this.precisionMethod = method
  }
  getValue() {
    const value = super.getValue()
    return precisionMetrics(value, this.precision, this.precisionMethod)
  }
}
